export interface Service {
  id: string;
  title: string;
  description: string;
  details: string[];
  icon: string;
}

export const services: Service[] = [
  {
    id: "verzinken",
    title: "Verzinken",
    description:
      "Hochwertige Zinkbeschichtungen für optimalen Korrosionsschutz. Wir verarbeiten sowohl Trommelware als auch Gestellware mit höchster Präzision.",
    details: [
      "Feuerverzinken und Elektroverzinken",
      "Schichtdicken nach Kundenvorgabe",
      "Passivierung und Versiegelung",
      "Chromatierung nach DIN-Normen",
    ],
    icon: "ri-shield-check-line",
  },
  {
    id: "phosphatieren",
    title: "Phosphatieren",
    description:
      "Phosphatierung zur Verbesserung der Korrosionsbeständigkeit und als Grundierung für nachfolgende Beschichtungen oder Lackierungen.",
    details: [
      "Manganphosphatierung",
      "Zinkphosphatierung",
      "Eisenphosphatierung",
      "Ölung und weitere Nachbehandlungen",
    ],
    icon: "ri-drop-line",
  },
  {
    id: "bruenieren",
    title: "Brünieren",
    description:
      "Brünieren von Stahlteilen zur Erzeugung einer schwarzen, korrosionsbeständigen Oberfläche mit dekorativer und funktioneller Wirkung.",
    details: [
      "Wärmebrünieren",
      "Kaltbrünieren",
      "Dekorative Oberflächenveredelung",
      "Ölung und Nachbehandlung",
    ],
    icon: "ri-fire-line",
  },
  {
    id: "trommelware",
    title: "Dickschichtpassivierung",
    description:
      "Dickschichtpassivierung von verzinkten Bauteilen zur Erhöhung des Korrosionsschutzes.",
    details: [
      "Erhöhter Korrosionsschutz",
      "Verbesserte Oberflächenbeständigkeit",
      "Geeignet für verzinkte Bauteile",
    ],
    icon: "ri-stack-line",
  },
  {
    id: "gestellware",
    title: "Versiegelung",
    description:
      "Versiegelung beschichteter Bauteile zur zusätzlichen Steigerung des Korrosionsschutzes.",
    details: [
      "Zusätzlicher Korrosionsschutz",
      "Verbesserte Oberflächeneigenschaften",
      "Erhöhte Beständigkeit der Beschichtung",
    ],
    icon: "ri-grid-line",
  },
];